import { gql, useQuery } from '@apollo/client';

export const GET_CURRENT_COMPANY = gql`
  query getCurrentCompany {
    getCurrentCompany {
      _id
      name
      businessAddress
      email
      logoFileId
      phoneNumber
      timezone
      timezoneFullFormat
      street
      city
      country
      houseNumber
      zipCode
      ceo
      mainStreet
      mainHouseNumber
      mainZip
      mainCity
      logoUrl
      ownerMemberId
      createdBy
      subscriptionId
      datevNumberId
      datevNumber {
        _id
        datevNumber
      }
      parentCompanyId
      locations {
        _id
        name
        companyNumber
        datevNumber {
          _id
          datevNumber
        }
        businessAddresses {
          _id
          street
          city
          country
          zipCode
          holidayLocationId
          holidayLocation {
            name
          }
          departments {
            _id
            name
            costCenter
          }
        }
      }
      parentCompany {
        name
      }
    }
  }
`;

export const useGetCurrentCompany = ({
  onSuccess,
}: { onSuccess?: (company: any) => void } = {}) => {
  const { data, loading } = useQuery(GET_CURRENT_COMPANY, {
    ...(onSuccess && { onCompleted: onSuccess }),
    fetchPolicy: 'cache-and-network',
  });

  const getCurrentCompany = data?.getCurrentCompany || {};

  return {
    loading,
    company: getCurrentCompany,
  };
};
